import api from '@/api'

export default {

    getYWKBoard() : Promise<ywkMigration.board[]>{
        return api.get({
            url: `/api/hk/YWKboard/YWKboardList`,
        })
    },
    getArticles(articleQuery:ywkMigration.articleQuery) :Promise<ywkMigration.articleSet>{
        return api.post({
            url: `/api/hk/YWKboard/YWKarticleList`,
            data:articleQuery
        })
    }
}